import React from 'react';
import CPUSection from '../components/CPUSection';
import MainProjects from '../components/MainProjects';
import AllProjects from '../components/SectionProjects';
import DetailedProjects from '../components/DetailedProjects';

const SmartOrganization = () => {
  return (
    <>
      {/* CPU/AI Features Section */}
      <CPUSection />

      {/* Main Projects Section */}
      <MainProjects />

      {/* All Projects Testimonial Section */}
      {/* <AllProjects /> */}

      {/* Detailed Projects Section */}
      <DetailedProjects />
    </>
  );
};

export default SmartOrganization;

